const partners = 'partners';
const tenants = 'tenants';

const partitions = 'partitions';
const configuration = 'configuration';
const telecom = 'telecom';

const phones = 'phones';
const globalOptOut = 'globalOptOut';
const outboundMessages = 'outboundMessages';
const tcr = 'tcr';

const emailDirectMail = 'email-direct-mail';
const sms = 'sms';

const partnerIdParamKey = ':externalPartnerId';
const tenantIdParamKey = ':externalTenantId';
const partitionIdParamKey = ':externalPartitionId';

export const AccountManagementRoutes = {
    partners,
    tenants,
    managePartner: `${partners}/${partnerIdParamKey}`,
    manageTenant: `${partners}/${partnerIdParamKey}/${tenants}/${tenantIdParamKey}`,
    managePartition: `${partners}/${partnerIdParamKey}/${tenants}/${tenantIdParamKey}/${partitions}/${partitionIdParamKey}`,
} as const;

export const ManageTenantRoutes = {
    telecom,
    partitions,
    configuration,
} as const;

export const TelecomRoutes = {
    phones,
    globalOptOut,
    outboundMessages,
    tcr,
} as const;

export const ConfigurationRoutes = {
    emailDirectMail,
    sms,
} as const;
